export const SKELETON_COLOR = '#F4F4F4';
